export const buildListAsText = (list: string[]) => {
    return list.reduce((acc, item) => `${acc}\n- ${item}`, '');
};

export const buildListAsHTML = (list: string[]) => {
    return `${list.reduce((acc, item) => `${acc}<li>${item}</li>`, `<ul>`)}</ul>`;
};
